<div class="whiteboard-drawing-list-item">
    <div class="open-whiteboard">
        {{ whiteboard.name }}
        <span class="time">
      ({{ whiteboard.time }} Min.)
    </span>
    </div>
    <div class="tool-side-icon">
        @if (whiteboard.page_id) {
            <div>
        <span class="chapter">S.{{
                (whiteboard.page !== null &&
                    pageService.getRealPageNumber(whiteboard.page.index) > 0) ?
                    pageService.getRealPageNumber(whiteboard.page.index) : '-'
            }}</span>
                <span [ngStyle]="{backgroundColor: whiteboard.color}" class="circle-icon">
          <i [ngClass]="'fa ' + whiteboard.icon"></i>
        </span>
            </div>
        } @else {
            <div>
                <button (click)="addToPage()" class="circle-icon">
                    <i class="fas fa-link"></i>
                </button>
            </div>
        }

        <div class="dropdown sharing-dropdown">
            <button [attr.id]="'dropdownMenuWhiteboard' + whiteboard.id" aria-expanded="true" aria-haspopup="true"
                    class="open-submenu"
                    data-bs-toggle="dropdown" type="button">
                <i class="fa fa-caret-down"></i>
            </button>
            <div [attr.aria-labelledby]="'dropdownMenuWhiteboard' + whiteboard.id" [class.dropdown-menu-end]="'right'"
                 class="dropdown-menu">
                <app-whiteboard-drawings-list-item-context-menu
                        [whiteboard]="whiteboard"></app-whiteboard-drawings-list-item-context-menu>
            </div>
        </div>

    </div>
</div>
